import $ from "jquery";
import "owl.carousel";
import AOS from "aos";

// Initialize AOS
AOS.init();

$(document).ready(function () {
  // Dropdown Menu Toggle
  $(".drp_btn").click(function () {
    $(this).siblings(".sub_menu").slideToggle();
  });

  // Preloader
  setTimeout(function () {
    $("#preloader").fadeOut("slow");
  }, 500);

  // Owl Carousel Initializations
  $("#frmae_slider").owlCarousel({
    loop: true,
    margin: 10,
    autoplay: true,
    smartSpeed: 1500,
    nav: false,
    dots: true,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
    },
  });

  $("#company_slider").owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    autoplay: true,
    smartSpeed: 1500,
    dots: true,
    responsive: {
      0: { items: 2 },
      600: { items: 3 },
      1000: { items: 5 },
    },
  });

  $("#testimonial_slider").owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    autoplay: true,
    smartSpeed: 2500,
    dots: true,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
    },
  });

  $("#screen_slider").owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: true,
    autoplay: true,
    smartSpeed: 2500,
    center: true,
    responsive: {
      0: { items: 1 },
      600: { items: 3 },
      1000: { items: 5 },
    },
  });

  // Pricing Section Toggle
  $(".tog_block").click(function () {
    $(".tog_btn").toggleClass("month_active");
    $(".month").toggleClass("active");
    $(".years").toggleClass("active");
    $(".monthly_plan").toggleClass("active");
    $(".yearly_plan").toggleClass("active");
  });

  // FAQ Accordion
  $(".collapse.show").each(function () {
    $(this)
      .prev(".card-header")
      .find(".icon_faq")
      .addClass("icofont-minus")
      .removeClass("icofont-plus");
  });

  $(".collapse")
    .on("show.bs.collapse", function () {
      $(this)
        .prev(".card-header")
        .find(".icon_faq")
        .removeClass("icofont-plus")
        .addClass("icofont-minus");
      $(this)
        .prev(".card-header")
        .children("h2")
        .children(".btn")
        .addClass("active");
    })
    .on("hide.bs.collapse", function () {
      $(this)
        .prev(".card-header")
        .find(".icon_faq")
        .removeClass("icofont-minus")
        .addClass("icofont-plus");
      $(this)
        .prev(".card-header")
        .children("h2")
        .children(".btn")
        .removeClass("active");
    });

  // Purple Backdrop Effect
  function handlePurpleBackdrop() {
    if ($(window).width() < 768) {
      const mobile_mockup = $(".mobile_mockup")[0];
      if (mobile_mockup) {
        const position = mobile_mockup.getBoundingClientRect();
        if (position.top < window.innerHeight && position.bottom >= 0) {
          $(".purple_backdrop").css("opacity", "1");
        } else {
          $(".purple_backdrop").css("opacity", "0");
        }
      }
    } else {
      const free_text = $(".free_text")[0];
      if (free_text) {
        const position = free_text.getBoundingClientRect();
        if (position.top < window.innerHeight && position.bottom >= 0) {
          $(".purple_backdrop").css("opacity", "1");
        } else {
          $(".purple_backdrop").css("opacity", "0");
        }
      }
    }
  }

  $(window).on("resize scroll", handlePurpleBackdrop);

  // Scroll to Top
  const toTop = $(".go_top");
  toTop.on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $("html, body").offset().top,
      },
      400
    );
  });

  $(window).scroll(function () {
    const topPos = $(this).scrollTop();

    // Show/hide scroll to top button
    if (topPos > 750) {
      $(toTop).css("opacity", "1");
    } else {
      $(toTop).css("opacity", "0");
    }

    // Header fixed styles
    if (topPos >= 250) {
      $("header").addClass("fix_style");
    } else {
      $("header").removeClass("fix_style");
    }
    if (topPos >= 260) {
      $("header").addClass("fixed");
    } else {
      $("header").removeClass("fixed");
    }
  });

  // Mobile Menu Toggle
  $(".navbar-toggler").click(function () {
    if (
      $(this)
        .children("span")
        .children(".ico_menu")
        .hasClass("icofont-navigation-menu")
    ) {
      $(this)
        .children("span")
        .children(".ico_menu")
        .removeClass("icofont-navigation-menu")
        .addClass("icofont-close");
    } else {
      $(this)
        .children("span")
        .children(".ico_menu")
        .removeClass("icofont-close")
        .addClass("icofont-navigation-menu");
    }
  });

  // Toggle Wrap
  $(".toggle-wrap").on("click", function () {
    $(this).toggleClass("active");
    $("aside").animate({ width: "toggle" }, 200);
  });
});

// Make sure jQuery is available
window.jQuery = $;
